export const getPerformanceUrl = (workspaceId: string, agentId: string) => `
/business/workspaces/${workspaceId}/agents/${agentId}/performance`;

export const getCustomerBreakdownUrl = (workspaceId: string, agentId: string) => `
/business/workspaces/${workspaceId}/agents/${agentId}/performances`;

export const getActionBreakdownUrl = (workspaceId: string, agentId: string) => `
/business/workspaces/${workspaceId}/agents/${agentId}/performances`;
